export interface LayoutVisibility {
  showHeader: boolean
  showSidebarRight: boolean
  showSidebarLeft: boolean
  showOtherImages: boolean
}

function getLayoutVisibility(route: any, key: string): boolean {
  if (route.query[key]) {
    if (process.client)
      sessionStorage.setItem(key, route.query[key])

    return route.query[key] !== 'false'
  }
  return process.client ? sessionStorage.getItem(key) !== 'false' : true
}

export function useLayoutVisibility(route: any): LayoutVisibility {
  return {
    showHeader: getLayoutVisibility(route, 'header'),
    showSidebarRight: getLayoutVisibility(route, 'sidebar_right'),
    showSidebarLeft: getLayoutVisibility(route, 'sidebar_left'),
    showOtherImages: getLayoutVisibility(route, 'other_images'),
  }
}
